module.exports = __webpack_public_path__ + "logo2.svg?98868570dc3ec944c6eae32b18f0d06b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.svg
// module id = 450
// module chunks = 0